import { css } from 'styled-components';
export var borderRadius = {
  sm: 2,
  md: 4,
  lg: 4
};
export function getBorderRadius(size) {
  return css(["border-radius:", "px;"], borderRadius[size]);
}
//# sourceMappingURL=borderRadius.js.map